import { useCallback } from 'react'
import axios from 'axios'

export const useSearchTracking = () => {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'

  const trackSearchQuery = useCallback(
    async (query: string, resultsCount: number, market: string) => {
      if (isLocalhost) {
        return
      }

      try {
        const event = {
          eventType: 'search',
          objectType: 'SEARCH_QUERY',
          objectName: 'user_search',
          bookingData: [query],
          timestamp: new Date().toISOString(),
          metadata: {
            pageUrl: window.location.href,
            deviceType: navigator.userAgent.includes('Mobile')
              ? 'mobile'
              : 'desktop',
            resultsCount,
            market
          }
        }

        await axios.post('/api/track-events', event, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } catch (error) {
        console.error('Failed to track search event:', error)
      }
    },
    [isLocalhost]
  )

  return {
    trackSearchQuery
  }
}
